export default __webpack_public_path__ + "static/media/wecare-green-logo.23c7eb6b.png";